import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    height: "100vh",
    width: "100vw",
    boxSizing: "border-box",
    alignContent: "center",
    textAlign: "center",
    background: theme.colors.Background1,
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 9999,
  },
  logo: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    height: 64,
    "&.hide": {
      opacity: 0,
    },
  },
  logoTv: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    objectFit: "cover",
    transform: "translateZ(0)",
    willChange: "opacity",
    backfaceVisibility: "hidden",
  },
}));
